import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import { colors } from "@/utils/const";
import { useRouter } from "next/router";

function SectionTopLine({
  src = "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-line.svg",
  bgColor = colors.navy,
  sx,
}) {
  const { locale } = useRouter();

  const isArabic = locale === "ar";

  // memoized transform style (avoids new object each render)
  const imageStyle = useMemo(
    () => ({
      display: "block",
      width: "100%",
      height: "12px",
      objectFit: "cover",
      transform: isArabic ? "scaleX(-1)" : "scaleX(1)",
      ...sx,
    }),
    [isArabic, sx]
  );

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: bgColor,
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={src}
        alt="section top line"
        sx={imageStyle}
      />
    </Box>
  );
}

export default memo(SectionTopLine);
